import { create } from 'zustand'
import { SharedSlice, createSharedSlice } from '../../../slice'
import createPayRunsSlice, { PayRunsSlice } from './pay-runs/slice'
import createEditPayRunSlice, { EditPayRunSlice } from './pay-runs/edit/slice'
import createPaySummarySlice, { PaySummarySlice } from './pay-summary/slice'

type PayrollStore = PayRunsSlice &
  EditPayRunSlice &
  PaySummarySlice &
  SharedSlice & {
    resetPayrollStore: () => void
  }

const usePayrollStore = create<PayrollStore>()((...props) => {
  const [, get] = props
  return {
    ...createSharedSlice(...props),
    ...createPayRunsSlice(...props),
    ...createEditPayRunSlice(...props),
    ...createPaySummarySlice(...props),
    resetPayrollStore: () => {
      get().resetPayRunsSlice()
      get().resetEditPayRunSlice()
      get().resetPaySummarySlice()
      // Mark store as loading so any payroll page shows a loader
      // until its loader refetches data for the new company context.
      get().setIsLoading(true)
    },
  }
})

export default usePayrollStore
